import * as React from 'react';
import classNames from 'classnames';
import { API } from '@canvas-logic/clp-viewer3d';

import { Button, IconName } from '@canvas-logic/clp-shared-ui';

import { QrCodeDialog } from './QrCodeDialog';
import ThemeDefinition from '../../domain/ThemeDefinition';

import { Popover, usePopoverRef } from '../Popover';
import { useEffect, useMemo } from 'react';
import { useGetArLink } from '@/ui-kit/hooks';
import style from './WebArControl.module.css';

interface IProps {
  className?: string;
  api: API;
}

export const WebArControl = ({ api, className }: IProps) => {
  const { state, generate, link, reset } = useGetArLink({ api });
  const ref = usePopoverRef();

  useEffect(() => {
    if (state === 'ready') {
      ref.current?.open();
    }
  }, [state, ref]);

  const handleButtonClick = async () => {
    if (state === 'ready') {
      reset();
    } else {
      await generate();
    }
  };

  const buttonIcon: IconName = useMemo(() => {
    switch (state) {
      case 'idle':
        return 'ar';
      case 'ready':
        return 'close';
      case 'loading':
        return 'spinner';
    }
  }, [state]);

  return (
    <div className={classNames(style.root, className)}>
      <Popover
        ref={ref}
        trigger="none"
        closeOnClickOutside={true}
        onClose={reset}
        content={<QrCodeDialog className={classNames(style.dialog, ThemeDefinition.arControl.dialog)} link={link} />}
        animate
        delayOnHover={300}
        placement="bottom-end"
        useProvidedRoot
      >
        <Button variant="ternary" iconStart={buttonIcon} onClick={handleButtonClick} />
      </Popover>
    </div>
  );
};
